/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de compras.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmCompras from "../../../administracion/compras/FrmCompras.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmComprasPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmCompras">
      <FrmCompras />
    </SizeSoftXFrmPortatil>
  );
}
